var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandHolding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M559.729 392.208L424.676 491.722C406.896 504.814 385.007 512 362.977 512H15.999C7.25 512 0 504.751 0 496.003V400.02C0 391.271 7.25 384.022 15.999 384.022H71.37L117.867 346.279C138.865 329.282 164.989 320.034 191.987 320.034H351.976C371.474 320.034 386.848 337.406 383.599 357.402C380.974 373.149 366.225 384.022 350.226 384.022H271.981C263.232 384.022 255.982 391.271 255.982 400.02S263.232 416.017 271.981 416.017H392.592L512.263 327.845C530.059 314.66 555.073 318.503 568.197 336.312C581.306 354.09 577.509 379.117 559.729 392.208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHolding);
export default __webpack_public_path__ + "static/media/hand-holding.87813b4699dd594ccaa5b5ea598b3868.svg";
export { ForwardRef as ReactComponent };